import styled from 'styled-components';
import SendMessage from './component';

export default styled(SendMessage)`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .send-button {
    background-color: var(--primary500);
    border-radius: 4px;
    height: 48px;
    width: 48px;
    padding-top: 7px;

    &:hover {
      cursor: pointer;
    }

    &.inactive {
      background-color: var(--grey300);

      &:hover {
        cursor: default;
      }
    }
  }

  textarea {
    border: solid 1px white;
    width: 70%;
    margin: 20px 0;
    resize: none;

    &:focus {
      border: solid 1px white;
      box-shadow: inset 0 0 0 0 white;
      outline: white;
    }
  }
`;
